// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WebinarContent_wrapper__jRu2T"};